import { render, staticRenderFns } from "./ResetSend.vue?vue&type=template&id=74b2f30a&"
import script from "./ResetSend.vue?vue&type=script&lang=js&"
export * from "./ResetSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports